/* global debounce, localData */
const searchSponsors = (search) => {
  const scExhibitorList = document.querySelector('.sc-exhibitor-list');
  const scExhibitorListDropDown = scExhibitorList.querySelector('.exhibitor-list__search-dropdown');
  const post = document.querySelector('.sc-exhibitor-list #search');
  const postId = post.dataset.id;
  const kIndex = post.dataset.kindex;
  const request = new XMLHttpRequest();
  request.open('POST', localData.siteURL, true);
  request.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');
  request.send(`action=getSearchSponsors&keyword=${search}&id=${postId}&kindex=${kIndex}`);
  request.onreadystatechange = function () {
    if (this.readyState === 4 && this.status === 200) {
      scExhibitorList.querySelector('.exhibitor-list').innerHTML = '';
      const response = JSON.parse(this.responseText);
      let html = '';
      if (response.data.sponsors.length) {
        response.data.sponsors.forEach((element) => {
          html += `<a href="${element.href}" class="exhibitor-card"><div class="exhibitor-card__logo : d-flex-cc"><img width="160" src="${element.logo_src}" data-src="${element.logo_src}" alt="${element.logo_alt}" height="160"></div><div class="exhibitor-card__content"><div class="title : title--h4"><h4>${element.title}</h4></div></div></a>`;
        });
        scExhibitorList.querySelector('.exhibitor-list').innerHTML = html;
        scExhibitorListDropDown.classList.remove('is-open');
      } else {
        scExhibitorListDropDown.classList.add('is-open');
      }
    }
  };
};
const searchField = document.querySelector('.sc-exhibitor-list #search');
if (typeof (searchField) !== 'undefined' && searchField != null) {
  searchField.addEventListener('keyup', debounce(() => {
    searchSponsors(searchField.value);
  }, 150));
}
